import React from 'react';
import DatePicker from 'material-ui/DatePicker';
import areIntlLocalesSupported from 'intl-locales-supported';
import { format } from 'date-fns';
const esLocale = require('date-fns/locale/es')

let DateTimeFormat;

if (areIntlLocalesSupported(["es"])) {
    DateTimeFormat = global.Intl.DateTimeFormat;
} else {
    const IntlPolyfill = require('intl');
    DateTimeFormat = IntlPolyfill.DateTimeFormat;
    require('intl/locale-data/jsonp/es');
}

export default class ToolbarComponent extends React.Component {
    state = {
        start: "",
        end: ""
    }

    startPicker = React.createRef();
    endPicker = React.createRef();

    static getDerivedStateFromProps(nextProps, prevState) {
        let state = {}
        if(nextProps.start)
            state["start"] = format(
                nextProps.start,
                "DD/MM/YYYY",
                {locale: esLocale},
            )
        if(nextProps.end)
            state["end"] = format(
                nextProps.end,
                "DD/MM/YYYY",
                {locale: esLocale},
            )
        return state
    }

    openPicker = (ref) => {
        ref.openDialog()
    }

    render() {
        return (
            <div className="navbar">
                <div style={{width: 0, height: 0, overflow: "hidden"}}>
                    <DatePicker id="start" ref={ref => this.startPicker=ref}
                        DateTimeFormat={DateTimeFormat}
                        value={this.props.start}
                        onChange={(event, date) => this.props.handleChange(event, date, "start")}
                        cancelLabel="Cancelar"
                        locale={"es"}
                    />
                    <DatePicker id="end" ref={ref => this.endPicker=ref}
                        DateTimeFormat={DateTimeFormat}
                        value={this.props.end}
                        onChange={(event, date) => this.props.handleChange(event, date, "end")}
                        cancelLabel="Cancelar"
                        locale={"es"}
                    />
                </div>
                <div className="navbar-brand">
                    <div className="navbar-item">
                        <h1>Movimientos</h1>
                    </div>
                </div>
                <div className="navbar-menu is-active">
                    <div className="navbar-item">
                        <div className="field has-addons">
                            <div className="control">
                                <input onFocus={() => this.openPicker(this.startPicker)}
                                    value={this.state.start}
                                    placeholder="Fecha de inicio"
                                    className="input" type="text"
                                    readOnly={true}
                                    />
                            </div>
                            <div className="control">
                                <a onClick={() => this.openPicker(this.startPicker)}
                                    className="button is-link">
                                    <i className="fas fa-calendar-alt"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="navbar-item">
                        <div className="field has-addons">
                            <div className="control">
                                <input onFocus={() => this.openPicker(this.endPicker)}
                                    value={this.state.end}
                                    placeholder="Fecha de fin"
                                    className="input" type="text"
                                    readOnly={true}
                                    />
                            </div>
                            <div className="control">
                                <a onClick={() => this.openPicker(this.endPicker)}
                                    className="button is-link">
                                    <i className="fas fa-calendar-alt"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/movements/components/toolbar/index.js